"use strict";
/* --------------------------------------------------------------------------------
 * Copyright: Altair Engineering, Inc., 2020.  All rights reserved.
 * Contains trade secrets of Altair Engineering, Inc.
 * Copyright notice does not imply publication.
 * Decompilation or disassembly of this software is strictly prohibited.
 * --------------------------------------------------------------------------------*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = exports.HttpClient = void 0;
const axios_1 = __importDefault(require("axios"));
const uuid_1 = require("uuid");
class HttpClient {
    constructor(options) {
        this._headers = new Headers();
        this._initializeRequestInterceptor = () => {
            this._instance.interceptors.request.use(this._handleRequest);
        };
        this._handleRequest = (config) => {
            var _a;
            const headers = (_a = config.headers) !== null && _a !== void 0 ? _a : {};
            headers.sourceid = `AOneUI-${(0, uuid_1.v4)()}`;
            this._headers.forEach((value, key) => {
                headers[key] = value;
            });
            config.headers = headers;
            return config;
        };
        const { baseURL = '' } = options || {};
        this.baseURL = baseURL;
        this._instance = axios_1.default.create({
            baseURL,
            withCredentials: true,
        });
        this._initializeRequestInterceptor();
    }
    get(url, config) {
        return this._instance.get(url, config);
    }
    delete(url, config) {
        return this._instance.delete(url, config);
    }
    head(url, config) {
        return this._instance.head(url, config);
    }
    options(url, config) {
        return this._instance.options(url, config);
    }
    post(url, data, config) {
        return this._instance.post(url, data, config);
    }
    put(url, data, config) {
        return this._instance.put(url, data, config);
    }
    patch(url, data, config) {
        return this._instance.patch(url, data, config);
    }
    setHeader(name, value) {
        this._headers.set(name, value);
    }
    deleteHeader(name) {
        this._headers.delete(name);
    }
    setBaseURL(baseURL) {
        this._instance.defaults.baseURL = baseURL;
    }
}
exports.HttpClient = HttpClient;
exports.httpClient = new HttpClient();
